export default __webpack_public_path__ + "static/media/hero-the-double.93997fd8.jpg";